import { createSelector } from '@ngrx/store';
import { getHistoryOrderStatus } from '../getHistoryOrderStatus';

export const isHistoryOrderReady = (orderGUID: string) => createSelector(getHistoryOrderStatus(orderGUID), (status) => status === OLO.Enums.ONLINE_ORDER_STATUS.FINALIZED);
